import React from 'react';
import { Navigate } from 'react-router-dom';
import { logNavigationError } from '../utils/AnalyticsEventsLogger';
import { PAGES } from '../page-urls';

export const On404 = () => {
  logNavigationError(window.location.pathname);
  return <Navigate to={PAGES.START.url} />;
};
